import React, { useCallback, useMemo } from 'react'
import DualListBox from 'react-dual-listbox'
import 'react-dual-listbox/lib/react-dual-listbox.css'
import { Box, CircularProgress } from '@material-ui/core'
import { GoldProductType } from '../../../services/sell/sell-typed'
import styled from '@emotion/styled'

export const CustomStyledDualListBox = styled(DualListBox)`
  & .rdl-control {
    overflow-x: auto;
  }
`

type Props = {
  selectedProducts?: string[]
  onSetSelectedProducts?: (products: string[]) => void
  isLoading?: boolean
  products?: GoldProductType[]
}

const CategoryProductsSelect = (props: Props) => {
  const { isLoading = false, selectedProducts = [], onSetSelectedProducts, products = [] } = props

  const mapProductsToOptions = useCallback(
    (products: GoldProductType[]) =>
      products.map(product => ({
        label: `${product.cardName} - ${product.name} - ${product.brand}`,
        value: String(product.id),
      })),
    [],
  )

  const options = useMemo(() => {
    if (isLoading) {
      return []
    }
    return mapProductsToOptions(products)
  }, [isLoading, mapProductsToOptions, products])

  return (
    <div style={{ width: '1000px', minHeight: '200px' }}>
      {isLoading ? (
        <Box style={{ display: 'flex', padding: 16, justifyContent: 'center' }}>
          <CircularProgress />
        </Box>
      ) : (
        <div>
          <CustomStyledDualListBox
            options={options}
            selected={selectedProducts}
            onChange={newValue => {
              const values = newValue as string[]
              if (onSetSelectedProducts) {
                onSetSelectedProducts(values)
              }
            }}
            showOrderButtons
            preserveSelectOrder
            canFilter
            filterCallback={(option: any, filterInput) =>
              option?.label?.toLowerCase().includes(filterInput?.toLowerCase()) ||
              (option?.value && option?.value?.includes(filterInput?.toLowerCase()))
            }
          />
        </div>
      )}
    </div>
  )
}

export default CategoryProductsSelect
